import router from './';
import store from '../store';
import { setPageTitle, checkIfTokenValid } from '../utils/util';

const whiteList = ['/login', '/register', '/terms', '/error'];

router.beforeEach(async (to, from, next) => {
	// 设置页面标题
	setPageTitle(to.meta.title);
	const hasToken = !!store.state.user.token;
	if (hasToken && checkIfTokenValid()) {
		if (to.path === '/login') {
			next({ path: '/', replace: true });
		} else {
			next();
		}
	} else {
		if (whiteList.includes(to.path)) {
			return next();
		}
		next('/login');
	}
});
